import app from 'flarum/forum/app';
import Notification from 'flarum/forum/components/Notification';
/** "Someone declined my friend request" notification. Subject is the decliner. */
export default class FriendshipDeclinedNotification extends Notification {
  icon() {
    return 'fas fa-user-times';
  }
  href() {
    const user = this.attrs.notification.subject();
    return user ? app.route.user(user) : '#';
  }
  content() {
    const fromUser = this.attrs.notification.fromUser();
    const data = this.attrs.notification.content() || {};
    const name = fromUser?.displayName() ?? data.declinerName ?? '?';
    return app.translator.trans('forumaker-friendship.forum.notifications.declined_text', {
      name: m("strong", null, name)
    });
  }
  excerpt() {
    return null;
  }
}
flarum.reg.add('forumaker-friendship', 'forum/components/FriendshipDeclinedNotification', FriendshipDeclinedNotification);